import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCartItems, setMyCartModalVisibility } from "../../store/actions";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const ProductSpecialCard = ({ element, isMobile }) => {
    const dispatch = useDispatch();
    const cartItems = useSelector((state) => state.cartItems);
    const myCartModalVisibility = useSelector((state) => state.myCartModalVisibility);

    // Build image and product link URLs
    const file_url = "/media/" + element.product_slug + element.cover_image;
    const product_image_url = `url('${file_url}')`;
    const product_link = "/product/" + element.product_slug;
    const titleColor = element.title_color;
    const subtitleColor = element.subtitle_color;
    const priceColor = element.price_color;
    const original_price = element.product_price;
    const discount = element.product_discount;
    const location = useLocation();
    const { prevProduct, nextProduct } = location.state || {};

    // In den Warenkorb logic
    function btnAddToCart(e, element) {
        const product = cartItems.find((x) => x.product_id === element.product_id);
        if (!product) {
            element.product_quantity = 1;
            dispatch(setCartItems([...cartItems, element]));
            dispatch(setMyCartModalVisibility(!myCartModalVisibility));
        } else {
            dispatch(setCartItems(cartItems.filter((x) => x.product_id !== element.product_id)));
        }
    }

    // Define button classes similar to ProductCard
    const circleBtnClasses =
        "d-flex align-items-center justify-content-center text-primary hover-white bg-hover-primary w-45px h-45px rounded-circle mb-2 border";
    const productInCart = cartItems.find((x) => x.product_id === element.product_id);
    let btnAddToCartClass = "add-to-cart " + circleBtnClasses;
    btnAddToCartClass += !productInCart ? " bg-white" : " bg-danger";

    return (
        <div className="grid-item gc-sm-2 gr-start-7 gr-start-sm-4 gr-start-lg-2 product">
            <div className="card border-0">
                <div
                    style={{ backgroundImage: product_image_url }}
                    className="card-img ratio bg-img-cover-center ratio-sm-1-2"
                ></div>
                <div className="card-img-overlay d-inline-flex flex-column p-xl-8  text-right">
                    <div>
                        <p class="h1" style={{ color: titleColor }}> {element.product_name} </p>
                        <p class="h6 text-uppercase letter-spacing-05 fs-13 font-weight-500" style={{ color: subtitleColor }}>{element.category}</p>
                        <p class="mt-auto mb-0 font-weight-500" style={{ color: priceColor }}>{original_price.toFixed(2)} EUR</p>
                    </div>
                    <div className="ml-auto d-flex flex-column hover-change-content ">
                        <div className="my-auto content-change-vertical">
                            <button
                                onClick={(e) => btnAddToCart(e, element)}
                                data-toggle="tooltip"
                                data-placement="left"
                                title="In den Warenkorb"
                                className={btnAddToCartClass}
                            >
                                <i className="far fa-shopping-basket"></i>
                            </button>
                            <button
                                onClick={() => (window.location = product_link)}
                                data-toggle="tooltip"
                                data-placement="left"
                                title="Preview"
                                className="preview d-flex align-items-center justify-content-center text-primary bg-white hover-white bg-hover-primary w-45px h-45px rounded-circle mb-2 border"
                            >
                                <i className="far fa-eye"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductSpecialCard;